export const PROPERTY = {
    FURNISHING_STATUS: {
        FURNISHED: 'Furnished',
        PARTLY_FURNISHED: 'Partly Furnished',
        UNFURNISHED: 'Unfurnished'
    },
    OCCUPANCY_STATUS: {
        AVAILABLE: 'Available',
        VACANT:  'Vacant',
        PARTLY_OCCUPIED: 'Partly occupied',
        OCCUPIED: 'Occupied',
    },
    OCCUPANCY_TYPES: {
        SINGLE :'Single occupancy',
        SHARED:'Shared occupancy',
    },
    RENT_CYCLES: {
        DAILY: 'per night',
        // WEEKLY: 'per week',
        // MONTHLY: 'per month',
        // QUARTERLY: 'per quarter',
        // YEARLY: 'per year',
    },
    SUBSCRIPTION_STATUS: {
        ACTIVE: 'active',
        EXPIRED: 'expired',
        CANCELLED: 'cancelled',
        RENEWED: 'renewed',
    },
    USER_TYPES: {
        LANDLORD: 'landlord',
        TENANT: 'tenant',
        HOMEOWNER: 'homeowner',
        TRADESPERSON: 'tradesperson'
    },
    LETTINGS_TYPES: {
        SHORTLETS: 'Short-let',
        LONGLETS: 'Long-term'
    },
    PARKING_TYPES: { 
        STREET: 'Street',
        GARAGE: 'Garage', 
        UNDERGROUND: 'Underground',
        OFFSITE: 'Offsite',
    },
    CURRENCY: {
        GBP: 'GBP',
        USD: 'USD',
        NGN: 'NGN',
        EUR: 'EUR',
    },
    STANDARD_FACILITIES: {
        WIFI: 'Wi-Fi',
        AIR_CONDITIONING: 'Air conditioning',
        FULLY_EQUIPED_KITCHEN: 'Full Equiped Kitchen',
        HOUSEKEEPING: 'Housekeeping',
        WORK_DESK: 'Work desk',
        OUTSIDE_SPACE: 'Outside space',
    },
    STANDARD_FACILITIES_NEW:  {
  HAS_BREAKFAST: 'Breakfast included',
  HAS_INTERNET: 'Free Internet',
  HAS_AIRPORT_TRANSFER: 'Transfer',
  HAS_PARKING: 'Parking',
  HAS_KIDS: 'Suitable for children',
  HAS_POOL: 'Swimming Pool',
  HAS_FITNESS: 'Fitness centre',
  HAS_MEAL: 'Bar or restaurant',
  HAS_DISABLED_SUPPORT: 'For guests with disabilities',
  HAS_BUSINESS: 'Conference hall',
  HAS_SPA: 'Spa Services',
  HAS_SKI: 'Ski slope nearby',
  BEACH: 'Beach nearby',
  AIR_CONDITIONING: 'Air-conditioning',
  HAS_PETS: 'Pets allowed',
  HAS_JACUZZI: 'Jacuzzi',
  PRIVATE_BATHROOM: 'Private Bathroom',
  KITCHEN: 'Kitchen',
  HAS_WASHER: 'Washing machine',
  BALCONY: 'Balcony',
  WITH_VIEW: 'View from the window',
  HAS_SMOKING: 'Smoking allowed',
  HAS_ECAR_CHARGER: 'Electric car charging',
  HAS_SKI_SHUTTLE: 'Ski lift transfer',
  HAS_SKI_TO_DOOR: 'Ski-in/ski-out',
  HAS_SKI_EQUIP_RENT: 'Ski facilities rental',
  HAS_SKI_STORAGE: 'Ski storage',
  HAS_SKI_DRYING_ROOM: 'Ski drying room',
  HAS_SKI_SCHOOL: 'Ski school',
  HAS_SKIING: 'Skiing',
  HAS_SNOWBOARD: 'Snowboard',
  HAS_SKI_WALKING_DISTANCE: 'Walk to ski lift',
},
    EXTRA_FEATURES: {
        CONCIERGE: 'Concierge',
        RESTAURANT_BAR: 'Restaurant / Bar',
        SELF_CHECKIN: 'Self check-in',
        SECURITY: '24/7 Security',
        MEETING_ROOM: 'Meeting room',
        GYM: 'Gym',
        ONSITE_PARKING: 'Onsite parking',
        OFFSITE_PARKING: 'Offsite parking',
    },
    HOUSE_RULES: {
        PETS_ALLOWED: 'Pets allowed',
        SMOKING_ALLOWED: 'Smoking allowed'
    },
    SAFETY_CHECKS: {
        SMOKE_ALARM: 'smoke',
        CO_ALARM: 'co'
    },
    PROPERTY_DISTANCE: {
        TEN_MILES: '10',
        SIXTY_MILES: '60',
        TWENTY_MILES: '20',
        EIGHTY_MILES: '80',
        THIRTY_MILES: '30',
        HUNDRED_MILES: '100',
        FIFTY_MILES: '50',
    },
    

}
